import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {cgTypeEnum} from '../../../../../../utilities/enums/cgTypeEnum';
import {handleURL} from '../../../../../../utilities/StringHelpers/StringHelpers';
import BtnRightSideText from '../../../../../Shared/Buttons/BtnRightSideText';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../../../Shared/Popup/PopUp';
import PlaneLoader from '../../../../AbroadTicketBlock/PlaneLoader';
import PaymentCG from '../../../../SaleBlock/PaymentCG/PaymentCG';
import PaperPlane from '../../SVG/PaperPlane';
import Phone from '../../SVG/Phone';
import './ccInsertScreen.scss';
import gaParams from '../../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../../utilities/analytics/tracking';

const CCInsertScreen = (props) => {
  useEffect(() => {
    gaEvent(
      gaParams.SEPARATED_CCINSERTSCREEN_SHOW.category,
      gaParams.SEPARATED_CCINSERTSCREEN_SHOW.eventType,
      gaParams.SEPARATED_CCINSERTSCREEN_SHOW.eventParams
    );
  }, []);

  const proceedToNext = () => {
    gaEvent(
      gaParams.SEPARATED_CCINSERTCONTINUE_CLICK.category,
      gaParams.SEPARATED_CCINSERTCONTINUE_CLICK.eventType,
      gaParams.SEPARATED_CCINSERTCONTINUE_CLICK.eventParams
    );
    if (props.isTermsAccepted) {
      const retObj = {
        customerCCNumber: props.CCToken,
        customerCCMonth: props.form.CardDueMonth,
        customerCCYear: props.form.CardDueYear,
        customerCCType: props.CCType,
      };
      props.handler(retObj);
    }
  };

  return (
    <>
      <div className='SeparatedSale_CGContainer'>
        <div className='subscriberHeading'>מנוי {props.subscriber}</div>
        <div className='mainHeading'>איך משלמים?</div>
        <PaymentCG
          isShowTerms={true}
          type={cgTypeEnum.CHECKCARD}
          customerId={props.customerId}
          isSeparatedSale={true}
          isShowIdNumber={true}
          source="CellcomAbroadLobbyBlock"
        />
      </div>
      <div className='cellcomSeparatedCCScreen_separatedFooter'>
        <BtnRightSideText text='המשך' isBusiness={true} onclick={proceedToNext} isGreyBg={!props.isTermsAccepted} />
      </div>
      <div className='cellcomSeparatedCCScreen'>
        {props.data.isLoading ? (
          <div className='loader-wrapper'>
            <PlaneLoader />
          </div>
        ) : null}
        <PopUp
          showPopUp={props.popupUpdate}
          onClose={() => {
            props.popupUpdateSet(false);
          }}>
          <div className='mainHeading p-0 m-0'>שנייה, משהו פה לא הסתדר</div>
          <div className='plane'>
            <PaperPlane />
          </div>
          <div className='popupExplanation'>
            <b>לא הצלחנו לעדכן את אמצעי התשלום החדש</b>
            <br />
            אפשר לנסות שוב עוד מספר דקות
          </div>
          <BtnRightSideText
            isBusiness={true}
            onClick={() => {
              props.popupUpdateSet(false);
            }}
            text='סיום'
          />
          {props.canProceed && (
            <a
              href='#'
              className='popupCloseLink'
              onClick={() => {
                gaEvent(
                  gaParams.SEPARATED_CONTINUEWITHCURRENTPAYMENT_CLICK.category,
                  gaParams.SEPARATED_CONTINUEWITHCURRENTPAYMENT_CLICK.eventType,
                  gaParams.SEPARATED_CONTINUEWITHCURRENTPAYMENT_CLICK.eventParams
                );
                props.ticketMove();
              }}>
              אוקיי, אמשיך עם אמצעי התשלום הקיים
            </a>
          )}
        </PopUp>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.PaymentCG.form,
    CCToken: state.PaymentCG.CCToken,
    CCType: state.PaymentCG.CCType,
    isTermsAccepted: state.PaymentCG.isTermsAccepted,
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CCInsertScreen);
